export enum DailyNoteChoice {
  NoNotesRequired = 1,
  CPTNoteRequired = 2,
  DailyNoteRequired = 3,
  DailyAndCPTNoteRequired = 4,
  DailyOrCPTNoteRequired = 5
}

// Optional: mapping to display names (note_choice strings)
export const DailyNoteChoiceLabels: { [key in DailyNoteChoice]: string } = {
  [DailyNoteChoice.NoNotesRequired]: 'No notes required',
  [DailyNoteChoice.CPTNoteRequired]: 'CPT note required',
  [DailyNoteChoice.DailyNoteRequired]: 'Daily note required',
  [DailyNoteChoice.DailyAndCPTNoteRequired]: 'Daily note & CPT note required',
  [DailyNoteChoice.DailyOrCPTNoteRequired]: 'Daily note or CPT note required'
};